import useTestId from '@ori/testid-generator';
import type { FunctionComponent } from 'react';
import { lazy, Suspense } from 'react';

import type { RevieveProps } from '../components';
import { APP_NAME } from '../constants';
import { useNovageSkincareAdvisor } from '../contexts';
import { isValidNovageSkincareConfiguration } from '../utils';

const Revieve = lazy<FunctionComponent<RevieveProps>>(async () =>
  import(/* webpackChunkName: "NovageSkincareAdvisor_Revieve" */ '../components/Revieve').then((module) => ({
    default: module.Revieve,
  })),
);

export const NovageSkincareAdvisor = () => {
  const { novageSkincareConfiguration, openQueryParam } = useNovageSkincareAdvisor();
  const { getTestId } = useTestId();

  return (
    <div data-testid={getTestId(APP_NAME)}>
      <Suspense fallback={null}>
        {isValidNovageSkincareConfiguration(novageSkincareConfiguration) ? (
          <Revieve
            novageSkincareConfiguration={novageSkincareConfiguration}
            openQueryParam={openQueryParam}
          />
        ) : null}
      </Suspense>
    </div>
  );
};
